<template>
  <div class="home_wrap">
    <van-nav-bar :title="title" left-text="" left-arrow :fixed="true" @click-left="onClickLeft" />
    <div class="setting-content">
      <div class="setting-head">
        <div class="setting-head-img">
          <div class="user-avatar">
            <img src="../../../logo.png" alt="" />
          </div>
          <div class="setting-head-vip">
            <img src="../../assets/images/person/vip.png" alt="" />
            <span data-text="1" style="color: #fff;">{{ userInfo.level }}</span>
          </div>
        </div>
        <div class="setting-head-txt">
          <span>{{ $t('配置') }}</span>
          <div class="setting-head-id">
            <section>ID:</section>
            <span>{{ userInfo.user_id }}</span>
            <span>
              <div class="svg_icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 26 26" fill="none">
                  <g clip-path="url(#clip0_2451_66248)">
                    <path
                      d="M2.793 24.794C2.44999 24.7937 2.12111 24.6573 1.87865 24.4146C1.6362 24.172 1.5 23.843 1.5 23.5V6.675C1.49961 6.50509 1.53278 6.33678 1.59762 6.17972C1.66246 6.02267 1.75769 5.87997 1.87783 5.75983C1.99798 5.63968 2.14067 5.54446 2.29773 5.47962C2.45478 5.41478 2.62309 5.3816 2.793 5.382H18.323C18.4929 5.3816 18.6612 5.41478 18.8183 5.47962C18.9753 5.54446 19.118 5.63968 19.2382 5.75983C19.3583 5.87997 19.4535 6.02267 19.5184 6.17972C19.5832 6.33678 19.6164 6.50509 19.616 6.675V23.5C19.6169 23.6704 19.5842 23.8393 19.5196 23.997C19.455 24.1546 19.3599 24.298 19.2398 24.4188C19.1196 24.5396 18.9768 24.6355 18.8194 24.7009C18.6621 24.7663 18.4934 24.8 18.323 24.8L2.793 24.794ZM3.44 22.853H17.674V7.325H3.44V22.853ZM21.556 20.59V3.442H8.941C8.6911 3.43066 8.4552 3.3234 8.28236 3.14254C8.10953 2.96169 8.01308 2.72116 8.01308 2.471C8.01308 2.22084 8.10953 1.98031 8.28236 1.79946C8.4552 1.6186 8.6911 1.51134 8.941 1.5H22.529C22.787 1.50237 23.0337 1.60639 23.2155 1.78949C23.3972 1.97259 23.4995 2.21999 23.5 2.478V20.589C23.506 20.7202 23.4853 20.8513 23.4391 20.9743C23.393 21.0973 23.3225 21.2097 23.2317 21.3046C23.141 21.3996 23.0319 21.4752 22.9111 21.5268C22.7904 21.5785 22.6604 21.6051 22.529 21.6051C22.3976 21.6051 22.2677 21.5785 22.1469 21.5268C22.0261 21.4752 21.917 21.3996 21.8263 21.3046C21.7355 21.2097 21.665 21.0973 21.6189 20.9743C21.5727 20.8513 21.552 20.7202 21.558 20.589L21.556 20.59Z"
                      fill=""></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_2451_66248">
                      <rect width="26" height="26" fill="currentColor"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </span>
          </div>
        </div>
      </div>
      <van-form @submit="onSubmit" style="margin-top: 0.8rem">
        <van-row>
          <van-col offset="" span="24">
            <van-field v-model="userInfo.username" disabled placeholder="" class="setting-input">
              <template #left-icon>
                <svg width="20" height="20" class="blueSvg" viewBox="0 0 48 48.001">
                  <defs>
                    <clipPath id="ggCHVIDK-clip-path">
                      <path id="ggCHVIDK-Union_151" data-name="Union 151"
                        d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z"
                        transform="translate(181 2519)"></path>
                    </clipPath>
                  </defs>
                  <g id="ggCHVIDK-input_icon_zh" transform="translate(-2322 -2123)">
                    <g id="ggCHVIDK-底层" transform="translate(2322 2123)">
                      <g id="ggCHVIDK-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                        clip-path="url(#ggCHVIDK-clip-path)">
                        <path id="ggCHVIDK-底层-2" data-name="底层"
                          d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                          transform="translate(0 0)"></path>
                      </g>
                    </g>
                    <path id="ggCHVIDK-icon_dl_zh"
                      d="M4.328,46.837A3.348,3.348,0,0,1,1,43.473v-.147A22.079,22.079,0,0,1,12.009,25.609a17.332,17.332,0,0,0,23.875,0A22.072,22.072,0,0,1,46.87,43.326,3.344,3.344,0,0,1,43.7,46.833h-.149Zm7.185-33.4A12.419,12.419,0,1,1,24.054,25.675h-.119A12.327,12.327,0,0,1,11.513,13.442Z"
                      transform="translate(2322 2123.163)"></path>
                  </g>
                </svg>
              </template>
            </van-field>
          </van-col>
          <!-- <van-col offset="" span="24">
            <van-field v-model="userInfo.mobile" disabled placeholder="" class="setting-input">
              <template #left-icon>
                <svg width="20" height="20" class="blueSvg" viewBox="0 0 48 48.001">
                  <defs>
                    <clipPath id="nICantol-clip-path">
                      <path id="nICantol-Union_151" data-name="Union 151"
                        d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z"
                        transform="translate(181 2519)"></path>
                    </clipPath>
                  </defs>
                  <g id="nICantol-input_icon_sj" transform="translate(-1578 -2123)">
                    <g id="nICantol-底层" transform="translate(1578 2123)">
                      <g id="nICantol-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                        clip-path="url(#nICantol-clip-path)">
                        <path id="nICantol-底层-2" data-name="底层"
                          d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                          transform="translate(0 0)"></path>
                      </g>
                    </g>
                    <path id="nICantol-icon_dl_sj"
                      d="M5634.75,1131.99h-19.2a4.859,4.859,0,0,0-4.8,4.917v38.168a4.858,4.858,0,0,0,4.8,4.915h19.188a4.884,4.884,0,0,0,4.8-4.946v-38.107a4.859,4.859,0,0,0-4.786-4.946Zm-9.6,46.295a2.221,2.221,0,1,1,2.166-2.218,2.188,2.188,0,0,1-2.166,2.233Zm10.435-8.072a1.46,1.46,0,0,1-1.583,1.638h-17.772a1.593,1.593,0,0,1-1.349-1.639v-30.887a1.613,1.613,0,0,1,1.6-1.638h17.5a1.617,1.617,0,0,1,1.6,1.638Z"
                      transform="translate(-4023.75 991.01)"></path>
                  </g>

                </svg>
              </template>
            </van-field>
          </van-col> -->
          <van-col offset="" span="24">
            <van-field v-model="userInfo.email" placeholder="Vincule o seu e-mail" class="setting-input">
              <template #left-icon>
                <img style="width: .4rem;height: .4rem;"
                  src="https://fsdgsfdg.brandypgapp.com/siteadmin/skin/lobby_asset/common/common/login/login_icon_yx02.avif?manualVersion=1&version=65af64437f"
                  alt="">
              </template>
              <template #extra>
                <span style="margin-top: -.1rem;">{{ $t("关联") }}</span>
              </template>
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <van-field v-model="userInfo.whatsapp" :clearable="true" :placeholder="$t('输入 WhatsApp ID')"
              class="setting-input">
              <template #left-icon>
                <svg width="20" height="20" viewBox="0 0 48 48.001">
                  <defs>
                    <clipPath id="aiCoDQvy-clip-path">
                      <path id="aiCoDQvy-Union_151" data-name="Union 151"
                        d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"
                        fill="#fff"></path>
                    </clipPath>
                  </defs>
                  <g id="aiCoDQvy-input_icon_whatsapp" transform="translate(-2917 -2123)">
                    <g id="aiCoDQvy-底层" transform="translate(2917 2123)">
                      <g id="aiCoDQvy-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                        clip-path="url(#aiCoDQvy-clip-path)">
                        <path id="aiCoDQvy-底层-2" data-name="底层"
                          d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                          transform="translate(0 0)" fill="#fff"></path>
                      </g>
                    </g>
                    <g id="aiCoDQvy-input_icon_whatsapp-2" data-name="input_icon_whatsapp"
                      transform="translate(2919 2125)">
                      <path id="aiCoDQvy-Path_6365" data-name="Path 6365"
                        d="M44,22A22,22,0,1,1,22,0,22,22,0,0,1,44,22Zm0,0" fill="#25d366"></path>
                      <path id="aiCoDQvy-Path_6366" data-name="Path 6366"
                        d="M96.384,76.106A13.678,13.678,0,0,0,74.472,91.928l-1.458,7.046a.534.534,0,0,0,.644.626l6.906-1.638A13.676,13.676,0,0,0,96.378,76.1h0ZM94.232,93.292a10.714,10.714,0,0,1-12.338,2l-.962-.476-4.234,1,.012-.052.878-4.26-.472-.93A10.708,10.708,0,0,1,94.234,78.148a.632.632,0,0,0,.056.056,10.706,10.706,0,0,1-.056,15.086h0Zm0,0"
                        transform="translate(-64.658 -63.83)" fill="#fff"></path>
                      <path id="aiCoDQvy-Path_6367" data-name="Path 6367"
                        d="M146.015,144.612a4.418,4.418,0,0,1-2.352,2.052c-1.8.434-4.542.014-7.966-3.176l-.042-.038c-3-2.8-3.8-5.114-3.6-6.954a4.4,4.4,0,0,1,1.71-2.6.976.976,0,0,1,1.53.35l1.108,2.49a.972.972,0,0,1-.122,1l-.56.726a.964.964,0,0,0-.086,1.076,10.483,10.483,0,0,0,1.9,2.108,11.064,11.064,0,0,0,2.63,1.884.95.95,0,0,0,1.042-.22l.65-.654a1,1,0,0,1,.97-.248l2.63.746a1,1,0,0,1,.558,1.472h0Zm0,0"
                        transform="translate(-116.867 -118.31)" fill="#fff"></path>
                    </g>
                  </g>
                </svg>
              </template>
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <van-field v-model="userInfo.facebook" :clearable="true" :placeholder="$t('输入 Facebook ID')"
              class="setting-input">
              <template #left-icon>
                <img style="width: .4rem;height: .4rem;" src="../../assets/images/index/facebook.png" alt="">
              </template>
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <van-field v-model="userInfo.telegram" :clearable="true" placeholder="Insira o ID do Telegram"
              class="setting-input">
              <template #left-icon>
                <svg width="20" height="20" viewBox="0 0 48 48.001">
                  <defs>
                    <clipPath id="CIvS9hGJ-clip-path">
                      <path id="CIvS9hGJ-Union_151" data-name="Union 151"
                        d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"
                        fill="#fff"></path>
                    </clipPath>
                  </defs>
                  <g id="CIvS9hGJ-input_icon_telegram" transform="translate(-2695 -2123)">
                    <g id="CIvS9hGJ-底层" transform="translate(2695 2123)">
                      <g id="CIvS9hGJ-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                        clip-path="url(#CIvS9hGJ-clip-path)">
                        <path id="CIvS9hGJ-底层-2" data-name="底层"
                          d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                          transform="translate(0 0)" fill="#fff"></path>
                      </g>
                    </g>
                    <g id="CIvS9hGJ-input_icon_telegram-2" data-name="input_icon_telegram"
                      transform="translate(2697 2125)">
                      <path id="CIvS9hGJ-Path_6358" data-name="Path 6358"
                        d="M44,22A22,22,0,1,1,22,0,22,22,0,0,1,44,22Zm0,0" fill="#039be5"></path>
                      <path id="CIvS9hGJ-Path_6359" data-name="Path 6359"
                        d="M79.251,123.812l21.2-8.124c.984-.354,1.842.238,1.524,1.718h0l-3.61,16.9c-.268,1.2-.984,1.49-1.986.926l-5.5-4.026-2.652,2.538a1.4,1.4,0,0,1-1.108.538l.4-5.56,10.188-9.146c.444-.388-.1-.6-.684-.22l-12.6,7.878L79,125.552c-1.178-.372-1.2-1.172.25-1.736h0Zm0,0"
                        transform="translate(-69.181 -102.26)" fill="#fff"></path>
                    </g>
                  </g>

                </svg>
              </template>
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <van-field v-model="userInfo.line" :clearable="true" :placeholder="$t('输入line ID')" class="setting-input">
              <template #left-icon>
                <svg width="20" height="20" viewBox="0 0 48 48.001">
                  <defs>
                    <clipPath id="2Y1jbMUh-clip-path">
                      <path id="2Y1jbMUh-Union_151" data-name="Union 151"
                        d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"
                        fill="#fff"></path>
                    </clipPath>
                  </defs>
                  <g id="2Y1jbMUh-input_icon_line" transform="translate(-2621 -2123)">
                    <g id="2Y1jbMUh-底层" transform="translate(2621 2123)">
                      <g id="2Y1jbMUh-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                        clip-path="url(#2Y1jbMUh-clip-path)">
                        <path id="2Y1jbMUh-底层-2" data-name="底层"
                          d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                          transform="translate(0 0)" fill="#fff"></path>
                      </g>
                    </g>
                    <g id="2Y1jbMUh-input_icon_line-2" data-name="input_icon_line" transform="translate(2623 2125)">
                      <circle id="2Y1jbMUh-Ellipse_167" data-name="Ellipse 167" cx="22" cy="22" r="22" fill="#39cd00">
                      </circle>
                      <g id="2Y1jbMUh-Group_3441" data-name="Group 3441" transform="translate(5.69 7.588)">
                        <path id="2Y1jbMUh-Path_6376" data-name="Path 6376"
                          d="M104.188,92.016a8.254,8.254,0,0,1-.126.976A10.74,10.74,0,0,1,102.83,96.5c-.292.52-1.7,2.5-2.13,3.02a38.032,38.032,0,0,1-13.024,9.388.878.878,0,0,1-1.256-.878l.336-3.024a.878.878,0,0,0-.776-.968,18.7,18.7,0,0,1-6.374-1.818A12.5,12.5,0,0,1,72,91.346c0-7.07,7.2-12.8,16.094-12.8A18.368,18.368,0,0,1,99.506,82.33a11.716,11.716,0,0,1,4.656,8.422,11.882,11.882,0,0,1,.026,1.256Zm0,0"
                          transform="translate(-72 -78.544)" fill="#fff"></path>
                        <g id="2Y1jbMUh-Group_3442" data-name="Group 3442" transform="translate(5.446 9.178)">
                          <path id="2Y1jbMUh-Path_6377" data-name="Path 6377"
                            d="M128.6,153.315a.8.8,0,0,1,.242.584.822.822,0,0,1-.822.824h-3.292a.828.828,0,0,1-.824-.826v-6.216a.812.812,0,0,1,.242-.584.822.822,0,0,1,1.4.584v5.4h2.47a.8.8,0,0,1,.58.24h0Zm0,0"
                            transform="translate(-123.9 -146.859)" fill="#00c200"></path>
                          <path id="2Y1jbMUh-Path_6378" data-name="Path 6378"
                            d="M168.216,147.544v6.574a.646.646,0,0,1-.644.644H167.2a.644.644,0,0,1-.644-.644v-6.574a.644.644,0,0,1,.644-.644h.36a.648.648,0,0,1,.654.644Zm0,0"
                            transform="translate(-160.838 -146.898)" fill="#00c200"></path>
                          <path id="2Y1jbMUh-Path_6379" data-name="Path 6379"
                            d="M194.458,147.722v6.18a.856.856,0,0,1-.828.858.83.83,0,0,1-.56-.228c-.028-.022-1.134-1.464-2.074-2.674-.7-.9-1.31-1.694-1.31-1.694v3.772a.824.824,0,0,1-1.646,0v-6.18a.85.85,0,0,1,.8-.858.832.832,0,0,1,.646.292c.034.042,1.736,2.254,2.692,3.512.38.49.644.836.644.836v-3.8a.822.822,0,0,1,1.644-.014Zm0,0"
                            transform="translate(-179.436 -146.898)" fill="#00c200"></path>
                          <path id="2Y1jbMUh-Path_6380" data-name="Path 6380"
                            d="M246.756,151.653v1.464h2.466a.826.826,0,1,1,0,1.648h-3.3a.824.824,0,0,1-.822-.824v-6.216a.824.824,0,0,1,.822-.822h3.292a.826.826,0,1,1,0,1.646h-2.458v1.464h2.466a.822.822,0,0,1,0,1.644h-2.466Zm0,0"
                            transform="translate(-228.844 -146.896)" fill="#00c200"></path>
                        </g>
                      </g>
                    </g>
                  </g>

                </svg>
              </template>
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <van-field v-model="userInfo.twitter" :clearable="true" :placeholder="$t('输入Twitter账号')"
              class="setting-input">
              <template #left-icon>
                <svg width="20" height="20" viewBox="0 0 48 48.001">
                  <defs>
                    <clipPath id="31z846aS-clip-path">
                      <path id="31z846aS-Union_151" data-name="Union 151"
                        d="M-137-2471v-4h4v4Zm-44,0v-4h4v4Zm44-44v-4h4v4Zm-44,0v-4h4v4Z" transform="translate(181 2519)"
                        fill="#fff"></path>
                    </clipPath>
                  </defs>
                  <g id="31z846aS-input_icon_twitter" transform="translate(-2769 -2123)">
                    <g id="31z846aS-底层" transform="translate(2769 2123)">
                      <g id="31z846aS-Mask_Group_1" data-name="Mask Group 1" transform="translate(0)" opacity="0"
                        clip-path="url(#31z846aS-clip-path)">
                        <path id="31z846aS-底层-2" data-name="底层"
                          d="M2,1A1,1,0,0,0,1,2V46a1,1,0,0,0,1,1H46a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2M2,0H46a2,2,0,0,1,2,2V46a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                          transform="translate(0 0)" fill="#fff"></path>
                      </g>
                    </g>
                    <g id="31z846aS-input_icon_twitter-2" data-name="input_icon_twitter"
                      transform="translate(2771 2125)">
                      <circle id="31z846aS-Ellipse_1" data-name="Ellipse 1" cx="22" cy="22" r="22"></circle>
                      <path id="31z846aS-path1009"
                        d="M484.006,356.79l10.516,14.06L483.94,382.282h2.382l9.264-10,7.486,10h8.1L500.06,367.43l9.85-10.64h-2.382L499,366.008,492.1,356.79Zm3.5,1.754h3.724l16.442,21.984H503.95Z"
                        transform="translate(-475.558 -347.536)" fill="#fff"></path>
                    </g>
                  </g>

                </svg>
              </template>
            </van-field>
          </van-col>
          <van-col offset="" span="24">
            <div style="
                font-size: 0.3rem;
                margin-top: 0.1rem;
                margin-bottom: 0.12rem;
                color: #fff;
              ">
              {{ $t("出生日期（一旦确定就无法更改）") }}
            </div>
            <van-field v-model="userInfo.birthday" :disabled="userInfo.birthday !== ''" :placeholder="$t('日 月 年')"
              class="setting-input" @click="showTime">
            </van-field>
            <div style="
                font-size: 0.3rem;
                margin-top: 0.1rem;
                margin-bottom: 0.12rem;
                color: #ffaa09;
              ">
              {{ $t("系统要求您年满18周岁，即出生前") }} 27/12/2006!
            </div>
          </van-col>
          <van-col offset="" span="24">
          </van-col>
        </van-row>
      </van-form>
      <van-popup v-model="show" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" :title="$t('选择日期')" cancel-button-text="Cancelar"
          confirm-button-text="Confirmar" :min-date="minDate" :max-date="maxDate" @confirm="timeChange" />
      </van-popup>
    </div>
    <div class="buttomTeam">
      <div class="retornar">{{ $t("返回") }}</div>
      <div class="salvar" @click="editUser">{{ $t("确定") }}</div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import {
  NavBar,
  Form,
  Field,
  CellGroup,
  Button,
  Col,
  Row,
  DatetimePicker,
  Popup,
} from "vant";

Vue.use(NavBar)
  .use(Form)
  .use(Field)
  .use(CellGroup)
  .use(Button)
  .use(Col)
  .use(Row)
  .use(DatetimePicker)
  .use(Popup);
export default {
  name: "setting",
  components: {},
  data() {
    return {
      userInfo: {
        username: "",
        mobile: "",
        email: "",
        whatsapp: "",
        facebook: "",
        telegram: "",
        line: "",
        twitter: "",
        birthday: "",
        flag: "1"
      },

      content: "",
      title: "Dados",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      show: false,
      time: "",
    };
  },
  created() {
    Fetch("/user/profile").then(res => {
      if (res.data.userinfo) {
        Object.assign(this.userInfo, res.data.userinfo)
      }
    })
  },
  beforeDestroy() { },
  mounted() {
  },
  methods: {
    onClickLeft() {
      this.$router.push("/person");
    },
    onSubmit() { },
    showTime() {
      if (this.userInfo.birthday !== "") {
        return
      }
      this.show = true;
    },
    editUser() {
      Fetch("/user/editProfile", {
        nickname: this.userInfo.nickname,
        email: this.userInfo.email,
        whatsapp: this.userInfo.whatsapp,
        facebook: this.userInfo.facebook,
        telegram: this.userInfo.telegram,
        line: this.userInfo.line,
        twitter: this.userInfo.twitter,
        birthday: this.userInfo.birthday,
        flag: "1"
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success({
            message: res.msg,
          });
        } else {
          this.$message.error({
            message: res.msg,
          });
        }
      }).catch((res) => {
        this.$message.error({
          message: res.msg,
        });
      }

      )
    },
    timeChange(value) {
      this.show = false;
      console.log(value)
      this.userInfo.birthday = this.dateToString(value);
    },
    dateToString(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString();
      var day = (date.getDate()).toString();
      if (month.length == 1) {
        month = "0" + month;
      }
      if (day.length == 1) {
        day = "0" + day;
      }
      var dateTime = year + "-" + month + "-" + day;
      return dateTime;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/.van-hairline--bottom::after {
  border: none;
}

/deep/.van-cell-group--inset {
  margin: 0;
}

/deep/ .van-field__control {
  color: @textcolor1;
}

/deep/ .van-cell::after {
  border: none;
}

/deep/ .van-field__control::placeholder {
  color: @textcolor1;
}

/deep/ .van-field__value {
  display: flex;
  align-items: center;
}

/deep/ .van-field__body {
  flex: 1;
}

/deep/ .van-icon {
  line-height: normal;
}

/deep/ .van-icon:before {
  color: @rechargeColor;
}

/deep/ .van-col--24 {
  margin-bottom: 0.2rem;
}

/deep/.van-picker {
  background-color: @activityColor;
}

/deep/ .van-picker__mask {
  width: 0;
}

/deep/ .van-picker__cancel {
  color: @popupTextColor;
}

/deep/.van-picker__title {
  color: #fff !important;
}

/deep/.van-picker__confirm {
  color: @ButtonColor;
}

/deep/ .van-ellipsis {
  color: @popupTextColor;
}

/deep/.van-picker__frame {
  //   background-color: @secondary-color;
}

/deep/ .van-picker-column__item--selected .van-ellipsis {
  color: #fff;
}

.buttomTeam {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  background-color: @primary-color;
  padding: 0.2rem 0.2rem 1.9rem;
  margin-top: 4.9rem;

  div {
    flex: 1;
    padding: .3rem;
    border-radius: .3rem;
  }

  .retornar {
    margin-right: .3rem;
    background-color: none;
    border: 0.01rem solid @rechargeColor;
    color: @rechargeColor;
    font-size: .35rem;
  }

  .salvar {
    background-color: @rechargeColor;
    color: @textcolor6;
    font-size: .35rem;
  }
}

.setting-input {
  background-color: @secondary-color !important;
  border: 0.01rem solid @bodercolor !important;
  border-radius: 0.2rem;
  color: #fff;
  font-size: 0.3rem;
  height: 1rem;
  width: 100%;
}

.blueSvg {
  fill: @textcolor1;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: @activityColor;
  padding-top: 1.2rem;
}

.setting-content {
  box-sizing: border-box;
  border-radius: 0;
  //   flex: 1;
  margin-bottom: 0;
  overflow: auto;
  margin: 0.2rem 0.2rem 0;
  padding: 0.2rem 0.2rem 0;

  .setting-head {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    height: 1.1rem;
    margin-bottom: 0.5rem;

    .setting-head-img {
      border-radius: 0.14rem;
      width: 1.5rem;
      position: relative;

      .user-avatar {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }

      .setting-head-vip {
        background: #24b299;
        color: @vipTextMoneyColor !important;
        font-size: 0.3rem;
        text-align: center;
        position: absolute;
        bottom: 0.04rem;
        right: 0;
        height: 0.3rem;
        max-width: 0.66rem;
        min-width: 0.5rem;
        padding: 0 0.035rem;
        border-radius: 0.04rem 0 0.04rem 0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: 0.3rem;
          width: 0.45rem;
          min-width: auto !important;
          margin-top: 0.01rem;
          flex-shrink: 0;

          span {
            font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue,
              Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui,
              Hiragino Sans GB, Microsoft Yahei, sans-serif;
            background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
            font-size: 0.22rem;
            font-style: italic;
            margin: -0.025rem 0 0 0.01rem;
            transform: scale(0.9);
            display: inline-block;
            font-weight: 700;
            position: relative;
            text-shadow: 0 0.01rem 0 rgba(0, 0, 0, 0.4);
            color: transparent;
          }

          span:before {
            background-clip: text;
            background-image: linear-gradient(180deg,
                #f7ea94,
                #e5b952 51%,
                #ce9510);
            background-size: cover;
            content: attr(data-text);
            height: 100%;
            left: 0;
            position: absolute;
            text-shadow: none;
            top: 0;
            width: 100%;
            z-index: 0;
            box-sizing: inherit;
            margin: 0;
            padding: 0;
          }
        }
      }
    }

    .setting-head-txt {
      margin-left: 0.4rem;
      font-size: 0.3rem;
      color: @popupTextColor;

      .setting-head-id {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }

    .setting-head-txt span:first-child {
      color: @ButtonColor !important;
    }
  }
}

.svg_icon {
  margin-left: 0.2rem;
}

.svg_icon path {
  fill: @ButtonColor;
}
</style>